import PropTypes from 'prop-types';
import {Segment} from 'semantic-ui-react';
import moment from 'moment-jalaali';

function Profile(props) {
  const {user, expireTime} = props.student;
  return (
    <Segment size='big'>
      <div>
        <span>نام و نام خانوادگی:</span>&nbsp;
        <span>{`${user.firstName} ${user.lastName}`}</span>
      </div>
      {(user.mobile) && (
        <div>
          <span>تلفن همراه:</span>&nbsp;
          <span lang='en'>{user.mobile}</span>
        </div>
      )}
      <div>
        <span>اعتبار فعلی:</span>&nbsp;
        <span lang='en'>{user.credit.toLocaleString()}</span>&nbsp;
        <span>ریال</span>
      </div>
      {expireTime && (
        <div>
          <span>زمان اتمام بسته مشاوره فعلی:</span>&nbsp;
          <span>{moment(expireTime).format('dddd jYYYY/jM/jD HH:mm')}</span>&nbsp;
        </div>
      )}
    </Segment>
  );
}

Profile.propTypes = {
  student: PropTypes.object
};

export default Profile;
